var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarmleadimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 29,
    viewBox: "0 0 81 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1505 13.4328C10.528 9.28773 3.54081 11.7057 1 13.4328V28.8984H81V11C64.8023 22.8428 61.0267 11.212 56.2626 6.77089C45.7818 -5.07216 43.8762 3.81013 39.1122 11.212C31.4897 21.5747 22.9145 16.3936 18.1505 13.4328Z",
    fill: "url(#paint0_linear_2513_32136)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19153 13.5C3.73234 11.7729 10.5285 9.28773 18.1509 13.4328C22.9149 16.3936 31.4902 21.5747 39.1126 11.212C43.8766 3.81013 45.7822 -5.07216 56.2631 6.77089C61.0271 11.212 64.1592 22.8428 80.3568 11",
    stroke: "#9EC985",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2513_32136",
    x1: 40.9622,
    y1: 1,
    x2: 40.9958,
    y2: 45.4115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24834,
    stopColor: "#E8F7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602811,
    stopColor: "#E1F6D5",
    stopOpacity: 0.29
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarmleadimg);
export default __webpack_public_path__ + "static/media/warmleadimg.92665207c7a07eda17c4359c1b33f39c.svg";
export { ForwardRef as ReactComponent };